import { focusOnMount } from './focusOnMount';
import { preventDefaultCallback } from './preventDefaultCallback';
import { stopPropagationCallback } from './stopPropagationCallback';

export const eventHelpers = {
    focusOnMount,
    preventDefaultCallback,
    stopPropagationCallback,
};
